import entryMixin from '@/assets/mixins/entry';
import langs from '@/assets/locale/lang/topic';
import { showToast } from '@/assets/utils/toast';

export default {
  langs,
  props: {
    customImgConfig: {
      type: Object,
      default: () => {
        return {};
      }
    },
    topicSdk: {
      type: Object,
      required: true
    }
  },
  mixins: [entryMixin],
  data() {
    return {
      entranceVisible: false,
      visible: false,
      topicData: {},
      answering: false,
    };
  },
  created() {
    this.topicSdk.getPendantList();
    this.bindEvents();
  },
  watch: {
    entranceVisible(val) {
      this.$emit('entry-visible-changed', val);
    },
    visible(val) {
      this.$emit('visible-changed', val);
    }
  },
  methods: {
    _getCoreSdk() {
      return this.topicSdk;
    },
    bindEvents() {
      const { topicSdk } = this;

      topicSdk.on(topicSdk.events.TOPIC_START, this.onStart);
      topicSdk.on(topicSdk.events.TOPIC_OVER, this.onOver);
      topicSdk.on(topicSdk.events.TOPIC_UPDATE_DATA, this.updateData);
      topicSdk.on(topicSdk.events.TOPIC_CHANGE_ENTRANCE, this.changeEntrance);
      topicSdk.on(topicSdk.events.TOPIC_DELETE, this.onDelete);
    },

    async onStart(topicData) {
      this.topicData = topicData;
      this.topicData.status = 'running';
      this.visible = true;
      this.entranceVisible = true;
    },
    onOver() {
      this.topicData.status = 'over';
    },
    changeEntrance(msg) {
      this.entranceVisible = msg.entranceEnable;
      if (!msg.entranceEnable) {
        this.visible = false;
      }
      const topicData = msg.detail;
      if (topicData?.status === 'running') {
        this.visible = msg.entranceEnable;
        this.topicData = topicData;
      }
    },
    closeModal(e) {
      e.preventDefault();
      this.visible = false;
    },
    async onDelete(msg) {
      if (!this.visible) return;
      if (this.topicData.id === msg.id) {
        showToast({ text: this.iarTrans('topic.deleteTopic') });
        this.visible = false;
      }
    },
    updateData(data) {
      // 删除话题后，话题没有任何数据时关闭弹窗
      if (!data) {
        this.visible = false;
        this.entranceVisible = false;
        return;
      }
      this.topicData = data;
    },
    async chooseAnswer(type) {
      try {
        if (this.answering) return;
        this.answering = true;
        await this.topicSdk.chooseAnswer(type);
        this.topicData.userIsAnswered = true;
        this.topicData.answer = type;
      } catch (e) {
        // 提交过答案，再次提交会报错，获取最新数据
        if (e.code === 502) {
          this.getTopicData();
        }
      } finally {
        this.answering = false;
      }
    },
    async clickEntrance() {
      await this.getTopicData();
    },
    async getTopicData() {
      try {
        this.topicData = await this.topicSdk.getTopicData();
        if (this.topicData.id) {
          this.visible = true;
        }
      } catch (e) {
        console.error('IAR Topic: ' + e.message);
      }
    }
  }
};
